export enum TableColumnTypeEnum {
  Text,
  TextOrNA,
  MultiValueOrNA,
  Number,
  Date,
  DateTime,
  SeverityLabel,
  StatusLabel,
  StatusLabelOrNA,
  Toggle,
  CopyableText,
  Link,
  LinkNewPage,
  InternalNavigation,
  Icon,
  TextWithIcon,
  Modified,
  LightningSupport,
  DropDownOptions,
  Actions,
  Label,
  Tag,
  SingleTag,
  TextWithIconAndTooltip,
  TextPopup,
  Avatar,
  Severities,
  AvatarsList,
  GroupsList,
}

export enum WidthType {
  Percentage,
  Pixel,
}

export interface ITableColumn {
  readonly labelPath: string;
  readonly propertyKey: string;
  readonly colType: TableColumnTypeEnum;
  readonly width: number;

  // This will be used to show the width type, dynamic or static
  // But also will be used on the main resource table to set if the column is resizable
  readonly widthType: WidthType;

  // User only when the type of the column is link
  readonly linkPropertyKey?: string;

  // Represent if the column value needs to be start with a capital letter and all other characters will be lower case
  readonly toCapitalize?: boolean;

  // Represent if a column is sortable.
  readonly isSortable?: boolean;
  // Represent if the column is sortable disabled.
  readonly isSortableDisabled?: boolean;
  // Represent the key used for the sort
  readonly sortKey?: string;
  // Invert the sort icon direction (for cases where backend sorts in reverse)
  readonly invertSortIcon?: boolean;

  // A path to the label which describes the column
  readonly descriptionLabelPath?: string;

  // Use only when the column is of type Internal Navigation
  readonly internalNavigationRoute?: string;
  readonly internalNavigationQuery?: string;

  // use when you need a specific style for the icon
  readonly iconTableClass?: string;

  // in case you want to add tooltip text for icon column
  readonly tooltipIconText?: string;

  readonly iconSrc?: string;
  readonly iconAlt?: string;

  // Use only when you want to add text on tooltip
  readonly tooltipDynamicText?: string;

  // Custom CSS class for the tooltip (defaults to 'tooltip-container')
  readonly tooltipClass?: string;

  readonly textColor?: string;

  // Use only for copyable column to show or hide the copyable text
  readonly withCopyIcon?: boolean;
  readonly iconOnly?: boolean;

  // Optional date format to override default rendering for Date/DateTime columns
  readonly dateFormat?: string;

  // Optional name of a boolean row property to apply disabled styling for this column
  readonly disabledProp?: string;

  // Use only when you want a border for your icon
  readonly iconBorder?: boolean;

  // Use only for copyable column the text
  readonly customCopyButtonTextLabel?: string;

  // Use only for popup column
  readonly textPopupTitleKey?: string;
  readonly textPopupTextKey?: string;

  // Enable text truncation with tooltip on hover for TextWithIcon columns
  readonly withTruncation?: boolean;

  // Will be used by the logic that handles the column shown
  // See usage example on ColumnsSelectionComponent
  readonly toggleState?: boolean;
  hidden?: boolean;
}
